import { observer } from 'mobx-react';
import React from 'react';
import classnames from 'classnames';

import { UiControlPropsType } from 'shared/types';

import './styles.scss';

type PropsType = UiControlPropsType<string | null> & {
    placeholder?: string
};

export const UiTextarea = observer(function UiTextarea({
    value,
    name = 'ui-textarea',
    className,
    onChange = () => undefined,
    placeholder,
}: PropsType) {
    return (
        <div className={classnames('ui-new-textarea', className)}>
            <textarea
                placeholder={placeholder}
                className={'ui-new-textarea__control ui-new-textarea__control--validation'}
                value={value || ''}
                name={name}
                onKeyDown={() => {
                }}
                onChange={e => {
                    onChange({
                        name,
                        value: e.target.value,
                    });
                }}
            />
        </div>
    );
});
